import emailSettings from './email_settings'

export default {
  ...emailSettings
}
